import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { gray4 } from '../../colours';

interface Props {
  children: ReactNode,
  onClick?: () => void,
}

const Container = styled.div`
  padding: 6px 8px;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    border-radius: 6px;
    background-color: ${gray4};
  }
`;

const TaskStatusDropdownItem = ({ children, onClick }: Props) => (
  <Container onClick={onClick}>
    {children}
  </Container>
);

TaskStatusDropdownItem.defaultProps = {
  onClick: () => { },
};

export default TaskStatusDropdownItem;
